exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inspektorat-view .add-button{margin-top:22px;float:none;min-width:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/inspektoratverwaltung/component/inspektoratView/inspektoratView.scss
// module id = 1zBu
// module chunks = 0